import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { SizingProgress } from '@/dto/scenario/sizing/SizingProgress';

type StorePath = `${string}/${string}`
type OverlayConfiguration = {
  progress: StorePath
  cancel: StorePath
}
type DisablePayload = {
  withCancel: boolean
}
type DISABLED_OVERLAY = typeof DISABLED_OVERLAY;
const DISABLED_OVERLAY = 'disabled';

export function buildOverlayModule() {
  @Module({
    namespaced: true
  })
  class Overlay extends VuexModule {
    private overlayConfiguration: OverlayConfiguration | DISABLED_OVERLAY = DISABLED_OVERLAY;

    @Action
    public async enable(overlayConfiguration: OverlayConfiguration): Promise<void> {
      this.context.commit('setOverlayConfiguration', overlayConfiguration);
    }

    @Action
    public async disable({ withCancel }: DisablePayload = { withCancel: false }): Promise<void> {
      if (withCancel && this.overlayConfiguration !== DISABLED_OVERLAY) {
        await this.context.dispatch(this.overlayConfiguration.cancel, undefined, { root: true });
      }
      this.context.commit('setOverlayConfiguration', DISABLED_OVERLAY);
    }

    @Mutation
    private setOverlayConfiguration(value: typeof this.overlayConfiguration): void {
      this.overlayConfiguration = value;
    }

    get isEnabled(): boolean {
      return this.overlayConfiguration !== DISABLED_OVERLAY;
    }

    get progress(): SizingProgress | undefined {
      if (this.overlayConfiguration !== DISABLED_OVERLAY) {
        return this.context.rootGetters[this.overlayConfiguration.progress];
      }
    }
  }

  return Overlay;
}
